export default __webpack_public_path__ + "static/img-channel-heading-pc-ac060840a3777c16e6d5ba278e7bb703.avif";